import { createTheme, darkScrollbar } from "@mui/material";

/**
 * Values from default theme to use in custom theme
 */
const { breakpoints, palette } = createTheme();

/**
 * Custom theme for Material UI
 */
export default createTheme({

  palette: {
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#F9473B",
      light: "#39a849"
    },
    text: {
      primary: "#333333",
      secondary: "#ffffff"
    },
    background: {
      default: "#E0E0E0",
      paper: "#ffffff"
    }
  },

  typography: {
    allVariants: {
      fontFamily: "poppins, sans-serif",
      fontWeight: 400
    },
    h1: {
      fontWeight: 600,
      fontSize: 22,
      [breakpoints.down("sm")]: {
        fontSize: "1.75rem"
      }
    },
    h2: {
      fontWeight: 600,
      fontSize: 20
    },
    h3: {
      fontWeight: 100,
      fontSize: 20
    },
    h4: {
      fontWeight: 100,
      fontSize: 20,
      color: "rgba(0, 0, 0, 0.5)",
      fontStyle: "italic",
      paddingLeft: 16
    },
    body1: {
      fontSize: 14
    },
    h5: {
      fontSize: 16
    },
    h6: {
      fontSize: 12
    },
    subtitle1: {
      fontFamily: "Quicksand, sans-serif",
      fontWeight: 700,
      fontSize: 16
    },
    body2: {
      fontSize: 14
    }
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@global": {
          a: {
            textDecoration: "none"
          }
        },
        body: palette.mode === "dark" ? darkScrollbar() : null
      }
    },
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
        position: "fixed"
      },
      styleOverrides: {
        root: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        },
        colorPrimary: {
          backgroundColor: "#000"
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          width: "100%"
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.54)"
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small"
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          alignItems: "center",
          justifyContent: "space-between"
        }
      }
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          left: "auto"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.5)",
          "&.Mui-checked": {
            color: palette.primary.main
          }
        }
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 5
      }
    },
    MuiCardMedia: {
      styleOverrides: {
        root: {
          width: "unset"
        }
      }
    }
  }

});